import { Component, ElementRef, ViewChild } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
//import { LoadingBarService } from '@ngx-loading-bar/core';
import { Router } from '@angular/router';
import { Agencies_BranchesProperties, AgencyListBaseData, AgencyMasterProperties } from '../models/AgencyMasterProperties';
import { DxDataGridComponent } from 'devextreme-angular';
import { AgencyService } from "../Services/Agency.service";
import { BranchService } from '../Services/branch.service';
import { BranchInformationProperties } from '../Models/BranchInformationProperties';
import { ManagerProperties } from '../Models/ManagerProperties';
import { ParentUsers } from '../Models/ActiveClasses';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TicketPnrRights } from '../Models/TicketIssuanceProperties';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';
import { UserStatisticsProps } from '../Models/UsersProperties';
declare var $;

@Component({
  selector: 'app-agency-list',
  templateUrl: './agency-list.component.html',
  styleUrls: ['./agency-list.component.css']
})
/** AgencyList component*/
export class AgencyListComponent {
  constructor(private ticketIssuanceService: TicketIssuanceService,private agencyService: AgencyService, private router: Router, private branchService: BranchService,private templateModel: NgbModal) { }
  @ViewChild('agencyGrid', { static: false }) dataGrid: DxDataGridComponent;
  agencyList: Agencies_BranchesProperties[] = [];
  collapsed = false;
  selectedValue: string;
  userId = 0;
  agencyCodeList$: Observable<Agencies_BranchesProperties[]>;
  agencyObj = new AgencyMasterProperties();
  branchObj = new BranchInformationProperties();
  imageSource: any;
  agenyListBaseData = new AgencyListBaseData();
  managerList: ManagerProperties[] = [];
  managerUserList:ParentUsers[]=[];
  managerListBool=false;
  backSystemCompanies: CompanyMasterProperties[] = [];
  totalAgencies: number = 0;
  activeAgencies: number = 0;
  notActiveAgencies: number = 0;
  @ViewChild('agencyMasterModal',null) agencyMasterModal:ElementRef;
  @ViewChild('baranchInformationModal',null) baranchInformationModal:ElementRef;
  tktPnrRight = new TicketPnrRights();
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };

  ngOnInit() {
    this.LoadAgencyList();
    this.imageSource = 'assets/img/Group 430.svg';
    this.AgecylistBaseData();
  }
  usersStat = new UserStatisticsProps();
  totalUsers: number = 0;
  activeUsers: number = 0;
  notActiveUsers: number = 0;
  LoadAgencyList = () => {
    try {
      let loginAgency = "";


      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("") != "") && (localStorage.getItem("AgencyId") != null)) {
        loginAgency = localStorage.getItem("AgencyId")
        if ((localStorage.getItem("UserId") != undefined) && (localStorage.getItem("UserId") != "") && (localStorage.getItem("UserId") != null))
          this.userId = Number(localStorage.getItem("UserId"));
        if (this.userId != 0) {
          this.agencyService.GetCompanyMaster().subscribe(res => {
            this.backSystemCompanies = res;

            this.agencyService.GetAllAgenciesForList(loginAgency, this.userId).subscribe((data) => {
              this.agencyCodeList$ = of(data);
              if (data.length > 0) {

                if (this.backSystemCompanies.length > 0) {
                  this.agencyList = data.map((agency) => {
                    const backsys = this.backSystemCompanies.find(back =>
                      back.companyId === Number(agency.backSystemCompanyName)
                    );
                    if (backsys) {
                      return { ...agency, backSystemCompanyName: backsys.companyName }
                    }
                    else {

                      return agency;
                    }
                  })
                }
                this.agencyList.sort(this.customSorting);
                this.activeAgencies = this.agencyList.filter(row => row.status === true).length;
                this.notActiveAgencies = this.agencyList.filter(row => row.status === false).length;
                this.totalAgencies = this.agencyList.length;
                this.agencyService.GetAllUsersFromParentBranchChildAgenciesForStatus(loginAgency).subscribe((data) => {
                  this.usersStat = data;
                  this.activeUsers = this.usersStat.activeUsers;
                  this.notActiveUsers = this.usersStat.inactiveUsers;
                  this.totalUsers = this.usersStat.totalUsers;

                });
              }
            });

          })

        }
      }
    }
    catch (e) {
    }
  }
  columns = [
    { dataField: 'code', caption: 'Code', alignment: 'center' },
    { dataField: 'name', caption: 'Name', alignment: 'center' },
    { dataField: 'backSystemCompanyName', caption: 'Back System Company', alignment: 'center' },
    { dataField: 'email', caption: 'Email', alignment: 'center' },
    { dataField: 'country', caption: 'Country', alignment: 'center' },
    { dataField: 'creationDate', caption: 'Creation Date', alignment: 'center' },
    {
      dataField: 'status', caption: 'Status', alignment: 'center',
      cellTemplate: this.getCellTemplate(),
      lookup: {
        dataSource: [
          { value: true, text: 'Active' },
          { value: false, text: 'Inactive' },
        ],
        valueExpr: 'value',
        displayExpr: 'text',
      },
    },
    { caption: 'Action', alignment: 'center', cellTemplate: this.getActionCellTemplate(), },
  ];
  getCellTemplate() {
    return (container: any, options: any) => {
      let data = options.data;
      const outerDiv = document.createElement('div');
      outerDiv.setAttribute('dxTemplate', "let data of 'cellTemplate'");
      const innerDiv = document.createElement('div');
      innerDiv.className = 'custom_margin';
      const label = document.createElement('label');
      label.className = 'switch';
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.disabled = !this.agenyListBaseData.canAddOrEditAgency || data.isMasterAdmin;
      checkbox.checked = data.status;
      checkbox.onchange = () => {
        if (this.agenyListBaseData.canAddOrEditAgency && !data.isMasterAdmin) {
          this.changeStatus(data.code, checkbox.checked);
        }
      };
      const span = document.createElement('span');
      label.appendChild(checkbox);
      label.appendChild(span);
      innerDiv.appendChild(label);
      outerDiv.appendChild(innerDiv);
      container.appendChild(outerDiv);
    };
  }
  //getActionCellTemplate() {
  //  return (container: any, options: any) => {
  //    const data = options.data;
  //    const outerDiv = document.createElement('div');
  //    outerDiv.setAttribute('dxTemplate', "let data of 'actionCellTemplate'");
  //    const anchor = document.createElement('a');
  //    anchor.href = '';
  //    anchor.onclick = (event) => {
  //      event.preventDefault();
  //      this.Edit_Click(data.code);
  //    };
  //    const icon = document.createElement('i');
  //    icon.className = 'uil uil-edit action-class';
  //    anchor.appendChild(icon);
  //    outerDiv.appendChild(anchor);
  //    container.appendChild(outerDiv);
  //  };
  //}
  getActionCellTemplate() {
    return (container: any, options: any) => {

      const data = options.data;

      const outerDiv = document.createElement('div');
      outerDiv.setAttribute('dxTemplate', "let data of 'actionCellTemplate'");

      const anchor = document.createElement('a');
      anchor.href = '';

      const icon = document.createElement('i');

      // ✅ Check permission
      if (this.agenyListBaseData.canAddOrEditAgency) {

        // EDIT BUTTON
        icon.className = 'uil uil-edit action-class';

        anchor.onclick = (event) => {
          event.preventDefault();
          this.Edit_Click(data.code);
        };

      } else {

        // VIEW BUTTON
        icon.className = 'uil uil-eye action-class';

        anchor.onclick = (event) => {
          event.preventDefault();
          this.Edit_Click(data.code); // create this function
        };

      }

      anchor.appendChild(icon);
      outerDiv.appendChild(anchor);
      container.appendChild(outerDiv);
    };
  }

  //LoadAgencyList = () => {
  //  try {
  //    let loginAgency = "";


  //    if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("") != "") && (localStorage.getItem("AgencyId") != null)) {
  //      loginAgency = localStorage.getItem("AgencyId")
  //      if ((localStorage.getItem("UserId") != undefined) && (localStorage.getItem("UserId") != "") && (localStorage.getItem("UserId") != null))
  //        this.userId = Number(localStorage.getItem("UserId"));
  //      if (this.userId != 0) {
  //        this.agencyService.GetCompanyMaster().subscribe(res => {
  //          this.backSystemCompanies = res;

  //          this.agencyService.GetAllAgenciesForList(loginAgency, this.userId).subscribe((data) => {
  //            this.agencyCodeList$ = of(data);
  //            if (data.length > 0) {

  //              if (this.backSystemCompanies.length > 0) {
  //                this.agencyList = data.map((agency) => {
  //                  const backsys = this.backSystemCompanies.find(back =>
  //                    back.companyId === Number(agency.backSystemCompanyName)
  //                  );
  //                  if (backsys) {
  //                    return { ...agency, backSystemCompanyName: backsys.companyName }
  //                  }
  //                  else {

  //                    return agency;
  //                  }
  //                })


  //              }
  //              this.agencyList.sort(this.customSorting);
  //              this.activeAgencies = this.agencyList.filter(row => row.status === true).length;
  //              this.notActiveAgencies = this.agencyList.filter(row => row.status === false).length;
  //              this.totalAgencies = this.agencyList.length;
  //            }
  //          });

  //        })

  //      }
  //    }
  //  }
  //  catch (e) {
  //  }
  //}
  customSorting(a: any, b: any): number {
    if (a.status === b.status) {
      return 0;
    }
    if (a.status === true) {
      return -1;
    }
    return 1;
  }

  //LoadAgencyList=()=> {
  //  try {
  //    let loginAgency = "";


  //    if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("") != "") && (localStorage.getItem("AgencyId") != null)) {
  //      loginAgency = localStorage.getItem("AgencyId")
  //      if ((localStorage.getItem("UserId") != undefined) && (localStorage.getItem("UserId") != "") && (localStorage.getItem("UserId") != null))
  //        this.userId = Number(localStorage.getItem("UserId"));
  //      if (this.userId != 0) {
  //        this.agencyService.GetCompanyMaster().subscribe(res => {
  //          this.backSystemCompanies = res;
            
  //            this.agencyService.GetAllAgenciesForList(loginAgency, this.userId).subscribe((data) => {
  //              this.agencyCodeList$ =of(data);  
  //              if(data.length>0){      
                           
  //                  if(this.backSystemCompanies.length>0){
  //                    this.agencyList= data.map((agency)=>{
  //                      const backsys= this.backSystemCompanies.find(back=>
  //                        back.companyId===Number(agency.backSystemCompanyName)
  //                      );
  //                      if(backsys){
  //                        return {...agency,backSystemCompanyName:backsys.companyName}
  //                      }
  //                      else{
                         
  //                        return agency;
  //                      }
  //                    })
                     

  //                  }  
                           
  //              }
  //            });
            
  //        })
         
  //      }
  //    }
  //  }
  //  catch (e) {
  //  }
  //}
  getrevenueRights() {
    this.ticketIssuanceService.CheckTktPnrRightsAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data2) => {
      this.tktPnrRight = data2;

    });
  }
  AgencyCodeChange=(value: string)=> {
    try {
      if (value != "" && value != null && value != undefined) {
        this.agencyService.GetAllAgencies(value, this.userId).subscribe((data) => {
          if(data.length>0){      
                           
            if(this.backSystemCompanies.length>0){
              this.agencyList= data.map((agency)=>{
                const backsys= this.backSystemCompanies.find(back=>
                  back.companyId===Number(agency.backSystemCompanyName)
                );
                if(backsys){
                  return {...agency,backSystemCompanyName:backsys.companyName}
                }
                else{
                 
                  return agency;
                }
              })
             

            }  
                   
        }
        });
      }
    }
    catch (e) { }
  }

  AgecylistBaseData() {
    try {
      let userIdLogin = Number(localStorage.getItem("UserId"));
      if (userIdLogin != null && userIdLogin != undefined) {
        this.agencyService.AgencyListBaseData(userIdLogin).subscribe((data) => {
          this.agenyListBaseData = data;


        });
      }
    }
    catch (e) {
      //////////console.log (e);
    }
  }
  OpenModel(targetmodel) {
    this.templateModel.open(targetmodel, {

      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
    })
  }
  public Edit_Click(agency_Branch: string) {
    this.managerListBool=false;
    localStorage.setItem("forAgencyMaster", agency_Branch);
    let loginAgencyId: string = localStorage.getItem("AgencyId");
    if (loginAgencyId != "" && loginAgencyId != undefined) {
      if (loginAgencyId == agency_Branch && loginAgencyId != "AG01") {
        
        if (agency_Branch.includes("B")) {
          this.branchService.GetBranchById(agency_Branch).subscribe((data) => {
            this.branchObj = data;
            if (this.branchObj.managers.length > 0){
              this.GetBranchUsers();
              this.managerList = this.branchObj.managers;
              this.managerListBool=true;
            }
            this.OpenModel(this.baranchInformationModal);
          })
        }
        else {
          this.agencyService.GetAgencyById(agency_Branch).subscribe((data) => {
            this.agencyObj = data;
            if (this.agencyObj.managers.length > 0){
              this.GetAgencyUsers();
              this.managerList = this.agencyObj.managers;
              this.managerListBool=true;
            }
            
            if (this.agencyObj.imageFile != "" && this.agencyObj.imageFile != null) {
              this.imageSource = 'data:image/jpg;base64,' + this.agencyObj.imageFile;

            }
            else {
              this.imageSource = 'assets/img/Group 430.svg';

            }
            this.OpenModel(this.agencyMasterModal);

          });
        }
     }
      else {
        if (agency_Branch.includes("B")) {
          localStorage.setItem('BranchListId', agency_Branch);
          this.router.navigateByUrl('/branchInformation');
        }
        else {
          localStorage.setItem('AgencyListId', agency_Branch);
          this.router.navigateByUrl('/agencyMaster');
        }
      }
    }

  }
  GetAgencyUsers() {
    try {
     
      let param = "";
      let isAgency;
      if (this.agencyObj.immediateParent == "" || this.agencyObj.immediateParent == null
        || this.agencyObj.immediateParent == this.agencyObj.parentAgency) {
        isAgency = true;
      }
      else
        isAgency = false;
      if (isAgency == true)
        param = this.agencyObj.parentAgency;
      else
        param = this.agencyObj.immediateParent;
      this.agencyService.GetUsersByParent(param, isAgency, this.agencyObj.agencyId).subscribe((data) => {
        this.managerUserList = data;
        
      })
    }
    catch (e) { }
  }
  GetBranchUsers() {
    try {
      let param = "";
      let isAgency;
      if (this.branchObj.immediateParent == "" || this.branchObj.immediateParent == null
        || this.branchObj.immediateParent == this.branchObj.agencyId) {
        isAgency = true;
      }
      else
        isAgency = false;
      if (isAgency == true)
        param = this.branchObj.agencyId;
      else
        param = this.branchObj.immediateParent;
      this.branchService.GetUsersByParent(param, isAgency,this.branchObj.branchId).subscribe((data) => {
        this.managerUserList = data;
      })
    }
    catch (e) { }
  }

  // Manage_Click(agencyId) {
  //   try {
  //     localStorage.setItem('AgencyIdRights', agencyId);
  //     this.router.navigateByUrl('/agencyRights');
  //   }
  //   catch (e) {

  //   }
  // }
  //end

  AddNewAgency() {
    try {
      this.router.navigateByUrl('/agencyMaster');
    }
    catch (e) { }

  }

  AddNewBranch() {
    this.router.navigateByUrl('/branchInformation');
  }

  changeStatus(agencyId, status) {

    this.agencyService.UpdateAgencyStatus(status, agencyId).subscribe((statusdata) => {
      if (statusdata != null && statusdata != false) {
        this.LoadAgencyList();
      }
    });


  }


}
